export const CHART_VIEW_MODES = {
	DAYS: "days" as const,
	ENTRIES: "entries" as const,
};

export const CHART_CONFIG = {
	DAYS_WINDOW: 28,
	ENTRIES_LIMIT: 30,
	ROLLING_AVERAGE_WINDOW: 7,
} as const;

export const FETCH_LIMITS = {
	REFLECTIONS: 5,
	DRAFTS: 3,
	RECENT_CHECKINS: 3,
} as const;

export const TEXT_TRUNCATION = {
	SHORT_DESCRIPTION: 100,
	MEDIUM_DESCRIPTION: 160,
	LONG_DESCRIPTION: 200,
	SENTENCES_TWO: 2,
	SENTENCES_THREE: 3,
} as const;
